import React  from 'react'
import DropDown from '../dropdown';
import { GetReservationSources } from '../../../api/services/pms';

const ReservationSourcesDropDown = ({...props}) => {
    return <DropDown search={false} api={GetReservationSources} textField="Name" valueField="Id"  {...props}/>
}

export default ReservationSourcesDropDown